<template>
  <div>
    <table class="table" v-if="runsLoaded && latestRuns.length > 0">
      <tr>
        <th v-if="!scheduleId">Job Name</th>
        <th>Run Date</th>
        <th>Status</th>
        <th>Results</th>
      </tr>
      <tr v-bind:key="schedule" v-for="schedule of latestRuns">
        <td v-if="!scheduleId">
          <router-link v-bind:to="'/job/edit/' + schedule.scheduleId">{{schedule.name}}</router-link>
        </td>
        <td>{{schedule.finishedTime.toLocaleDateString()}} {{schedule.finishedTime.toLocaleTimeString()}}</td>
        <td>
          <span v-if="schedule.status == 'SUCCESS'" class="badge badge-pill badge-success">success</span>
          <span v-if="schedule.status == 'ERRORS'" class="badge badge-pill badge-warning">errors</span>
          <span v-if="schedule.status == 'FAIL'" class="badge badge-pill badge-danger">failure</span>
        </td>
        <td>
          <b-link v-b-modal.job-run-result variant="link" v-on:click="loadResult(schedule.scheduleId, schedule.runId)">view</b-link>
        </td>
      </tr>
    </table>
    <p v-else-if="runsLoaded && latestRuns.length == 0">There are no job runs yet.</p>
    <b-modal id="job-run-result" title="Job Run Results" size="lg" hide-footer>
      <p class="my-6"></p>
      <div v-if="runResult.length > 0">

        <table class="table">
          <thead class="thead-dark">
            <tr>
              <th>Fragment</th>
              <th>Content</th>
            </tr>
          </thead>
          <tr v-bind:key="item" v-for="item of runResult">
            <td>{{item.name}}</td>
            <td v-if="item.value"><pre>{{item.value}}</pre></td>
            <td v-else-if="item.error">ERROR: {{item.error}}</td>
            <td v-else-if="item.img"><img class="image" :src="item.img" /></td>
            <td v-else></td>
          </tr>
        </table>
      </div>
      <div v-else>{{message}}</div>
    </b-modal>
  </div>
</template>
<script>
import axios from 'axios';
import jQuery from 'jquery';
import _ from 'lodash';
import CommonMixin from '../util/common';
import AppConfig from '../util/config';

export default {
  name: 'jobRuns',
  mixins: [CommonMixin],
  props: {
    limit: String,
    scheduleId: {
      type: String,
      default: null
    },
    mode: {
      type: String,
      default: "latest"
    }
  },
  data() {
    return {
      runResult: [],
      runLoaded: false,
      latestRuns: [],
      runsLoaded: false,
      message: ""
    }
  },
  methods: {
    getLatestSchedules() {
      var that = this;
      that.latestRuns = [];
      return this.backendGet("/schedule/latestRuns").then(result => {
        that.latestRuns = _.each(result.data, function(o) { 
            o.finishedTime = new Date(o.finishedTime * 1000);
        });
        that.runsLoaded = true;
      });
    },
    loadRuns(scheduleId) {
      var that = this;
      that.latestRuns = [];
      return this.backendGet("/schedule/runs/" + scheduleId).then(result => {
        that.latestRuns = _.each(result.data, function(o) { 
            o.finishedTime = new Date(o.finishedTime * 1000);
        });
        that.runsLoaded = true;
      });
    },
    loadResult(scheduleId, runId) {
      this.runLoaded = false;
      this.runResult = [];
      this.message = "Loading..."
      var that = this;
      return this.backendGet("/schedule/runs/" + scheduleId + "/" + runId).then(result => {
        that.runResult = result.data.result;
        that.runLoaded = true;
      });
    }
  },
  mounted() {
    if (this.scheduleId) {
      this.loadRuns(this.scheduleId).catch(err => {
        this.$emit("error", err);
      });
    } else {
      this.getLatestSchedules().catch(err => {
        this.$emit("error", err);
      });
    }
  },
  updated() {}
}
</script>

<style scoped>
pre {
    white-space: pre-wrap;       /* Since CSS 2.1 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
}
.image {
  max-width: 100%;
  max-height: 600px;
}
</style>